import { gql } from "@apollo/client";


export const GET_AUTORIZACION_CONTROL = gql`
    query autorizacionControlInProgress( $idEvaluacion: Int!){
        autorizacionControlInProgress( idEvaluacion: $idEvaluacion)
 }
`;